<template>
  <div v-if="!refreshChart" ref="pieCircleIndexBox" :class="[b(), className, 'pieCircleBox']"
       :style="{ styleSizeName }">
    <noDataSvg class="noDataSvg" :color="editorType === 1 ? '#787A80' : '#787A80'"
               v-show="!dataChart.length && isDataCenter"/>
    <div :style="{ ...mainStyle, ...contentboxStyle }"
         :class="['content-box', (!dataChart.length && isDataCenter) ? 'hideBox' : '']">
      <div :style="pieCircleStyle" class="pie-circle-left">
        <div :ref="id" class="pieCircle"></div>
        <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
                  :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
                  :option="option"
                  :drillClickList="drillClickList"
                  :drillDimList="drillDimList"></ChartNav>
      </div>
      <div
          v-if="option?.legend && option?.legendType == 'indexCard' && (dataChart.length || !isDataCenter)"
          :class="['index-card', option.layoutType !== 'column-reverse' ? 'index-card-vertical' : '']"
          :style="indexCardStyle"
      >
        <IndexCard
            :dCode="dcode"
            :mCode="mcode"
            ref="indexCard"
            :isPieCard="true"
            :getColor="getColor"
            :echartOption="echartOption"
            :dataOption="prop"
            :dataChart="dataChart"
            :schema="schema"
            :layoutType="option.layoutType"
        ></IndexCard>
      </div>
    </div>
  </div>
</template>
<script>
import IndexCard from "@/components/indexCard/IndexCard.vue";
import circleImg from "@/assets/img/circle.png";
import util from "@/option/common/util";
import noDataSvg from './svg.vue'
import {nextTick} from "vue";
import {setPx} from "@/echart/util";

export default {
  name: "pieCircleIndex",
  components: {
    IndexCard,
    noDataSvg,
  },
  data() {
    return {
      totalValue: 0,
      echartOption: {},
      refreshChart: false,
      showTotalValue: false,
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  watch: {
    // 这个配置修改后好像要重新渲染 不然显示有bug 暂时先这样处理下
    'option': {
      deep: true,
      handler() {
        setTimeout(() => {
          this.updateChart()
        })
      }
    }
  },
  computed: {
    pieCircleStyle() {
      if (this.styleChartName) {
        let style = this.styleChartName;
        delete style.width;
        delete style.height;
        if (this.option.legendType == "indexCard") {
          if (this.option.layoutType == "column-reverse") {
            style.width = "100%";
            style.height = this.option.layoutNumber
                ? this.option.layoutNumber + "%"
                : "50%";
          } else {
            style.width = this.option.layoutNumber
                ? this.option.layoutNumber + "%"
                : "50%";
            style.height = "100%";
          }
        } else {
          style.width = "100%";
          style.height = "100%";
        }
        style.height = this.drillIndex > -1 ? `calc(${style.height} - 20px)` : style.height;
        return style;
      }
    },
    mainStyle() {
      if (this?.styleChartName) {
        return {
          width: "100%",
          height: "100%",
        };
      }
    },
    schema() {
      return {prop: this.option};
    },
    contentboxStyle() {
      let option = this?.option;
      let style = {};
      style["flex-direction"] = option?.layoutType;
      if (option?.legendPosition?.startsWith('b')) {
        style["flex-direction"] = 'column';
      } else if (option?.legendPosition?.startsWith('l')) {
        style["flex-direction"] = 'row-reverse';
      }
      return style;
    },
    indexCardStyle() {
      let style = {};
      if (this?.option?.legendType == "indexCard") {
        if (this?.option?.layoutType == "column-reverse") {
          style.width = "100%";
          style.height = this?.option?.layoutNumber
              ? 100 - this.option.layoutNumber + "%"
              : "50%";
          style['overflow-x'] = 'scroll';
        } else {
          style.width = this?.option?.layoutNumber
              ? 100 - this.option.layoutNumber + "%"
              : "50%";
          style.height = "100%";
          style['overflow-y'] = 'scroll';
        }
      }
      return style;
    },
  },
  methods: {
    getUnit(name) {
      if (this.prop.metrics) {
        const fieldItem = this.prop.metrics.find(item => item.name === name || item.fieldName === name) || {}
        if (fieldItem?.set?.type === 'percent') {
          return '%'
        }
        return fieldItem?.set?.indexUnit || ''
      } else {
        return ''
      }
    },
    handlerDimParam(param) {
      // 指标环图结构
      param.componentType = 'indexRingGraph';
      return param
    },
    splitByNumber(name, number) {
      if (name.length > number * 2) {
        return [name.slice(0, number), name.slice(number, number * 2) + '...']
      } else if (name.length > number) {
        return [name.slice(0, number), name.slice(number, number * 2)]
      } else {
        return [name]
      }
    },
    updateChart() {
      const {
        chartSet: {
          legendSet = {}
        }
      } = this.themeCfg
      let {categories = [], series = []} = this.getDimentionOption();
      let nameList = [];
      let dataList = [];
      // 环图只取第一个指标 多了指标也没法展示
      this.dataChart.map((_el) => {
        nameList.push(_el[this.dcode]?.value)
        dataList.push(_el[this.mcode])
      })
      // 处理默认数据 没有配置指标维度的
      if (!this.isDataCenter) {
        dataList = this.dataChart.map(el => {
          return {value: el.value}
        })
        nameList = this.dataChart.map(el => el.name)
        series = [{
          name: '模拟数据',
          data: dataList
        }]
      }

      let optionData =
          series.length > 0
              ? dataList.map((it, index) => {
                return {
                  name: nameList[index] || "",
                  value: it.value * 1,
                  index: index,
                  ...it
                };
              })
              : [];
      if (this.option.notCount) {
        optionData = optionData.filter(ele => ele.value !== 0 && ele.value);
      }
      if (this.option.sort) {
        optionData.sort((a, b) => a.value - b.value);
      }
      const height = this.$refs.pieCircleIndexBox.clientHeight;
      if (height < 100) {
        return
      }
      const barColor = this.option.barColor || [];
      const totalMetrics = this.prop.totalMetrics;
      let label = {
        show: this.option.labelShow || this.option.isShowTotalIndex,
        rich: {
          name: {
            color: this.option.totalValueColor || (this.option.labelShowColor || "#333333"), // 后半部分兼容老的逻辑
            align: "center",
            fontSize: this.option.totalValueFontSize || (this.option.labelShowFontSize || 10), // 后半部分兼容老的逻辑
            lineHeight: this.option.totalValueTop ? (this.option.totalValueTop + 14) : 14, // 保持居中状态需要根据间距调整行高
            verticalAlign: "top",
            fontWeight: this.option.totalValueFontWeight || 'normal',
            padding: [0, 5, this.option.totalValueTop || 12, 5],
            borderRadius: 0,
          },
          rate: {
            width: 60,
            fontWeight: this.option.totalLabelFontWeight || 'normal',
            lineHeight: this.option.totalLabelLineHeight || 40,
            fontSize: this.option.totalLabelFontSize || 18,
            color: this.option.totalLabelColor || '#333333',
          },
        },
      };
      if (totalMetrics?.length && this.option.isShowTotalIndex) {
        this.showTotalValue = true
        this.totalValue = 0
        this.dataChart.forEach(item => {
          if (item[totalMetrics[0].code]) {
            this.totalValue += (item[totalMetrics[0].code].value || 0) * 1
          }
        })
        let totalObj = {
          name: totalMetrics[0].name,
          value: this.totalValue,
        }
        if (totalMetrics[0]?.set) {
          util.formatValue(totalMetrics[0]?.set, totalObj, 'value');
          totalObj.indexUnit = totalMetrics[0]?.set.indexUnit
        }
        label = {
          show: true,
          position: 'center',
          ...label,
          formatter: (params) => {
            let content = '';
            if (this.showTotalValue) {
              let name = []
              if (totalObj.name.indexOf('\\n') >= 0) {
                name = totalObj.name.split('\\n')
              }
              if (this.option.totalLabelWrapNumber) {
                name = this.splitByNumber(totalObj.name, this.option.totalLabelWrapNumber)
              }
              if (name.length) {
                content += `{name|${
                    totalObj.value
                }${totalObj.indexUnit || ''}}`
                name.forEach(itm => {
                  content += `\n{rate|${itm}}`
                })
              } else {
                content += `{name|${
                    totalObj.value
                }${totalObj.indexUnit || ''}}\n{rate|${totalObj.name}}`;
              }

            } else {
              if (this.option.labelContent?.includes('指标值')) {
                content += `{name|${params.value}}`
              }
              if (this.option.labelContent?.includes('维度值')) {
                let name = []
                if (this.option.totalLabelWrapNumber) {
                  name = this.splitByNumber(params.name, this.option.totalLabelWrapNumber)
                }
                if (name.length) {
                  name.forEach(itm => {
                    content += `\n{rate|${itm}}`
                  })
                } else {
                  content += `\n{rate|${params.name}}`
                }
              }
            }
            return content
          },
        };
      } else if (this.option.labelShow) {
        if (this.option.labelPosition === "inside") {
          label = {
            ...this.getOptionLabel({position: 'center'}),
            ...label,
            formatter: (params) => {
              let content = '';
              if (this.option.labelContent?.includes('指标值')) {
                content += `{name|${params.value}}`
              }
              if (this.option.labelContent?.includes('维度值')) {
                let name = []
                if (this.option.totalLabelWrapNumber) {
                  name = this.splitByNumber(params.name, this.option.totalLabelWrapNumber)
                }
                if (name.length) {
                  name.forEach(itm => {
                    content += `\n{rate|${itm}}`
                  })
                } else {
                  content += `\n{rate|${params.name}}`
                }
              }
              return content
            },
          };
        } else {
          label = {
            ...this.getOptionLabel(),
          }
        }
      }
      if (!this.option.showCenterLabel || (!this.option.isShowTotalIndex && !this.option.labelShow)) {
        label = {
          show: false
        }
      }
      let list = [
        {
          type: "pie",
          roseType: this.option.roseType ? "radius" : "",
          radius: [this.option.xRadius + '%', this.option.yRadius + '%'],
          center: [this.option.xCenter + '%', this.option.yCenter + '%'],
          // animationType: "scale",
          // animationEasing: "elasticOut",
          // animationDelay: function (idx) {
          //   return Math.random() * 200;
          // },
          name: series?.[0]?.name,
          label: label,
          labelLine: {
            show: label.show,
          },
          data: optionData,
          emphasis: {
            scale: !this.option.notShowEmphasis,
          },
          itemStyle: this.getHasProp(
              !this.switchTheme,
              {
                color: (params) => this.getColor(params.dataIndex),
                borderRadius: this.option.borderRadius || 0,
                borderWidth: this.option.borderWidth || 3,
                borderColor: this.option.borderColor || 'rgba(0, 0, 0, 0)',
              },
              {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                  label: {
                    show: label.show,
                    fontSize: 20,
                    fontWeight: "bold",
                  },
                },
              }
          ),
        },
        {
          type: "pie",
          radius: [this.option.yRadius + '%', this.option.yRadius + '%'],
          center: [this.option.xCenter + '%', this.option.yCenter + '%'],
          hoverAnimation: false,
          silent: true,
          data: [
            {
              value: 100,
              z: 1,
              label: {
                show: label.show,
                position: "center",
                formatter: () => {
                  return `{bg|}`;
                },
                rich: {
                  bg: {
                    left: "center",
                    width: height / 1.5,
                    height: height / 1.5,
                    backgroundColor: {
                      image: circleImg,
                    },
                  },
                },
              },
            },
          ],
        },
      ];
      const {notShowInner} = this.option
      if (notShowInner) {
        list = [list[0]]
      }
      let {legend} = this.option;
      let legends = {};
      if (this.option.legendType == "legend") {
        legends = this.getOptionLegend(optionData)
        legends = {
          ...legends,
          show: legend,
          align: 'left',
          type: this.option.isCurrent ? 'scroll' : 'plain',
          orient: this.option.layoutType === "row" ? "vertical" : 'horizontal',
          icon: this.option.legendIcon || "circle",
          itemWidth: this.option.legendW || 25,
          itemHeight: this.option.legendH || 14,
          textStyle: {
            color: this.option.legendFontColor || (legendSet?.color || "#ffffff"),
            fontSize: this.option.legendFontSize || (legendSet?.size || 12)
          },
          formatter: (name) => {
            let total = 0;
            let res;
            try {
              optionData.forEach((it) => {
                total += ((it._originVal || 0) * 1 || 0);
              });
              // 计算时要用原始值
              const {_originVal, value} = optionData.find((item) => item.name === name);
              const rate = !!total ? `${(((_originVal || 0) / total) * 100).toFixed(2)}%` : '0.00%';
              if (name.length > 10) {
                return `${name.substring(0, 8)}…　${rate}`;
              }
              let blank = "";
              for (let i = 0; i < (this.option.blankInterval || 10) - name.length; i++) {
                blank += "　";
              }
              let subBlank = "";
              let valStr = `${value}`;
              if (this.option.showPercentage == 'both') {
                for (let i = 0; i < (this.option.blankInterval || 10) - Math.floor(valStr.length / 2); i++) {
                  subBlank += "　";
                }
              }
              if (this.option.showPercentage == 'percentage') {
                res = `${name}${blank}${rate}`;
              } else if (this.option.showPercentage == 'both') {
                res = `${name}${blank}${value}${subBlank}${rate}`;
              } else {
                res = `${name}${blank}${value}`;
              }
            } catch (e) {
              res = `${name}`;
            }
            return res
          },
        };
      }

      let option = {
        title: this.getOptionTitle(),
        tooltip: {
          ...this.getOptionTip(),
        },
        grid: this.getOptionGrid(),
        series: list,
      };
      // 兼容老配置如果没有配置限制 默认开启 因为饼图很容易出现抖动问题
      if (!('tipConfine' in this.option)) {
        option.tooltip.confine = true
      }
      if (this.option.legendType == "legend") {
        option.legend = legends;
      }

      setTimeout(() => {
        this.myChart.resize();
        this.myChart.setOption(this.echartsOptionHandler(option), true);
      }, 300);
      this.echartOption = option
      if (totalMetrics?.length && this.option.isShowTotalIndex) {
        // this.myChart.dispatchAction({
        //   type: "highlight",
        //   seriesIndex: 0,
        //   dataIndex: 0,
        // });
      } else {
        this.myChart.dispatchAction({
          type: "downplay",
        });
      }
      // 更新指标卡
      nextTick(() => {
        this.$refs["indexCard"]?.handlerRes();
      })
      setTimeout(() => {
        this.myChart.off("mouseover");
        this.myChart.off("mouseout");
        this.myChart.on("mouseover", (e) => {
          if (this.option.labelShow && this.option.labelPosition === "inside") {
            this.myChart.dispatchAction({
              type: "downplay",
              seriesIndex: 0,
            });
            this.myChart.dispatchAction({
              type: "highlight",
              seriesIndex: 0,
              dataIndex: e.dataIndex,
              position: undefined,
            });
            option.series[0].label.show = false
            this.myChart.resize();
            this.myChart.setOption(this.echartsOptionHandler(option), true);
          }
          if (totalMetrics?.length && this.option.isShowTotalIndex) {
            this.myChart.dispatchAction({
              type: "downplay",
              seriesIndex: 0,
            });
            this.myChart.dispatchAction({
              type: "highlight",
              seriesIndex: 0,
              dataIndex: e.dataIndex,
            });
            this.showTotalValue = false
            option.series[0].label.show = false
            this.echartOption = option
            this.myChart.resize();
            this.myChart.setOption(this.echartsOptionHandler(option), true);
          }
        });
        this.myChart.on("globalout", (e) => {
          if (totalMetrics?.length && this.option.isShowTotalIndex) {
            this.showTotalValue = true
            option.series[0].label.show = true
            this.echartOption = option
            this.myChart.resize();
            this.myChart.setOption(this.echartsOptionHandler(option), true);
          }
          if (this.option.labelShow && this.option.labelPosition === "inside") {
            this.myChart.dispatchAction({
              type: "downplay",
            });
          }
        });
      }, 300);
    },
  },
};
</script>
<style lang="scss" scoped>
.pie-circle-left {
  overflow: hidden;
}

:deep(.avue-draggable__item) {
  width: 100%;
  height: 100%;
}

.pieCircleBox {
  width: 100%;
  height: 100%;
  position: relative;

  .noDataSvg {
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
  }
}

.content-box {
  width: 100%;
  height: 100%;
  display: flex;

  .pieCircle {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-shrink: 0;
  }

  .index-card {
    flex-shrink: 1;
  }

  .index-card::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  .index-card-vertical::-webkit-scrollbar:horizontal {
    display: none;
  }
}

.hideBox {
  opacity: 0;
  z-index: -1;
}
</style>




